/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommentAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CommentAction({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Comment/CommentAction"
  
}) {
let taskCommentCommentValueData = fromData.useDataValue({ viewPath,
context: 'task_comment',
path: 'comment',
})
let constantData = ''
let aggregateData = fromAggregate.equals(taskCommentCommentValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="task_comment.comment"
 data="''"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Comment"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}